<template>
  <div id="ticket" class="div_card">
    <div v-if="docRecord==null">      
      <el-alert
        title="資料讀取中…"
        type="info"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-if="docRecord!=null">
      <div v-if="docRecord[0].status==1">
        <table style="width: 100%;">
          <tr>
            <td class="td-style">姓名：</td>
            <td>{{docRecord[0].name}}</td>
          </tr>
          <tr>
            <td class="td-style">准考證號碼：</td>
            <td>{{docRecord[0].idNo}}</td>
          </tr>
          <tr>
            <td class="td-style">報考系所：</td>
            <td>{{docRecord[0].deptName}}</td>
          </tr>
          <tr>
            <td class="td-style">面試報到時間：</td>
            <td>{{docRecord[0].text[3]}}</td>
          </tr>
          <tr>
            <td class="td-style">面試報到地點：</td>
            <td>{{docRecord[0].text[2]}}</td>
          </tr>
          <tr>
            <td class="td-style">面試時間：</td>
            <td>{{docRecord[0].text[5]}}</td>
          </tr>
          <tr>
            <td class="td-style">面試地點：</td>
            <td>{{docRecord[0].text[4]}}</td>
          </tr>
          <tr>
            <td class="td-style">筆試時間：</td>
            <td>{{docRecord[0].text[0]}}</td>
          </tr>
          <tr>
            <td class="td-style">筆試地點：</td>
            <td>{{docRecord[0].text[1]}}</td>
          </tr>
          <tr>
            <td class="td-style" style="vertical-align: top;">注意事項一：</td>
            <td>
              <div style="white-space: pre-wrap;">{{docRecord[0].note1}}</div>
            </td>
          </tr>
          <tr>
            <td class="td-style" style="vertical-align: top;">注意事項二：</td>
            <td>
              <div style="padding: 0.5em 0 0;" 
                  v-html="docRecord[0].note2"/>
            </td>
          </tr>
        </table>
          <el-row style="padding: 1em 0 0;">
          <el-button type="primary" @click="print(user.dId)">准考證下載<i class="el-icon-view"></i></el-button>
          <!--<a :href="'./WebApi/Apply/GetAdmiTicketPDF/'+user.dId" class="ncut-btn-type"><span class="glyphicon glyphicon-download-alt" style="margin-right: 4px;" />准考證下載<i class="el-icon-download"></i></a>-->
        </el-row>
      </div>
      <div v-else-if="docRecord[0].status==4">
        <el-alert
          title="您的資格審查未通過，無法下載准考證。"
          type="error"
          show-icon
          center
          :closable="false">
        </el-alert>
      </div>
      <div v-else-if="docRecord[0].status==5">
        <el-alert
          title="請先完成網路報名。"
          type="error"
          show-icon
          center
          :closable="false">
        </el-alert>
      </div>
      <div v-else-if="docRecord[0].status==6">        
        <div v-html="memo1">
        </div>   
        <el-radio-group v-model="docRecord[0].othrInfo.flag1" >1">
            <el-radio :label="1">否</el-radio>
            <el-radio :label="2">是</el-radio>
        </el-radio-group>
        <div v-html="memo2">
        </div>   
        <el-radio-group v-model="docRecord[0].othrInfo.flag2" >1">
            <el-radio :label="1">否</el-radio>
            <el-radio :label="2">是</el-radio>
        </el-radio-group>
        <br/><br/>
        <el-checkbox  v-model="chkval">&nbsp;<span class="ncut-ipnut-form-text">本人已閱讀以上說明，且願意配合防護措施及個人資料的提供。</span></el-checkbox>
        <br/><br/>
        <el-button type="success" @click="save()">{{$t('message.Send_cmd')}}</el-button>   
      </div>
      <div v-else>
        <el-alert
          title="無准考證資料。"
          type="warning"
          show-icon
          center
          :closable="false">
        </el-alert>
      </div>
    </div>
    <div v-else>
      <el-alert
        title="尚無資料，請耐心等候，謝謝!!"
        type="warning"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
  </div> 
</template>


<script>
export default {
  name: 'ticket',
  data () {   
    return {      
        docRecord:null,     
        memo1: '',
        memo2: '',
        chkval: false 
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    isSuccess(str) {
      return ((str == "true") || (str == "True") || (str == true) ? true : false);
    },
    print(dId) {
      let url = './WebApi/Apply/GetAdmiTicketPDF/'.concat(dId);
      let params = new URLSearchParams();
      params.append('cdn', this.cdnSelect);

      this.$http.get(url, {    
                  responseType: 'blob',
                  params: params
                }).then((response) => {
                  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('target','_blank');
                  document.body.appendChild(link);
                  link.click();
                });
    },
    getVirusMemo(fNo) {
      return this.$http
                 .get('./WebApi/Apply/GetVirusMemo/'.concat(this.sysId).concat('/').concat(fNo));
    },
    checkData() {
      var ret = false;
      var msg = '';

      if(0 == this.docRecord[0].othrInfo.flag1){
        msg = '針對問題1，點選您的回答!';
      }

      if(0 == this.docRecord[0].othrInfo.flag2){
        msg = '針對問題2，點選您的回答!';
      }

      if(0 == this.chkval){
        msg = '勾選已閱讀以上說明聲明!';
      }

      if (msg.length > 0) {
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,請<i style="background:yellow;">'+msg+'</i>!</strong>',
                            offset: 150
                          });
      } else {
        ret = true;
      }
      return ret;
    },
    save() { 
      if(this.checkData()==true)
      {
        var vm = this; 
        vm.docRecord[0].dId=this.user.dId;
        vm.$http
        .put('./WebApi/Apply/SaveFlag',vm.docRecord[0])
        .then((success) =>{
                              if (vm.isSuccess(success.data)) {
                                vm.$message({
                                    message: '恭喜您,存檔成功',
                                    type: 'success'
                                  });                                
                                vm.query();
                              }
                          })
        .catch(function (error) {
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
        }) 
      }     
    },
    query() {   
      var vm = this;
    　this.$http
        .get('./WebApi/Apply/GetAdminTicket/'.concat(this.user.dId))
        .then(function(response) {
          if (response.data != null) {
            vm.docRecord = [response.data]
          } else {
            this.$notify.error({
                                title: this.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,讀取<i style="background:yellow;">報名資料</i>失敗</strong>',
                                offset: 150
                              });
          }
        })
        .catch(function (error) {
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
        })
    }
  },
  created () { 
    console.log('======created TicketView=====');
    this.query();
    var vm = this;
    vm.query();
    this.$http.all([vm.getVirusMemo(47)])
              .then(vm.$http.spread(function (memoInfo) {              
                vm.memo1 = memoInfo.data;                 
              }))
    this.$http.all([vm.getVirusMemo(48)])
              .then(vm.$http.spread(function (memoInfo) {             
                vm.memo2 = memoInfo.data;                 
              }))   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .td-style {
    width: 20%;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/TicketView.vue